// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"71533df3","52":"3e74ff2c","206":"8a3a7adb","416":"8490837c","452":"a2e74dca","453":"288dc29f","469":"f3f00ddf","541":"c354aff6","557":"40d5aaab","706":"25c842f1","841":"7275a8d4","936":"da5450cc","956":"d6797219","994":"36a9bd84"}[chunkId] + ".chunk.js";
};